// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__K7KWe","logo":"Navbar_logo__raDWX","nav":"Navbar_nav__g1Nth","testmarker":"Navbar_testmarker__FQY1D"};